import { ReactionData, ReactionType } from '../types';
import { Reaction } from './reaction';

export type ReactionTabType = 'all' | ReactionType;

export class ReactionTab {
	private _reaction?: Reaction;
	reactions: ReactionData[];
	type: ReactionTabType;

	constructor(type?: ReactionTabType) {
		this.reactions = [];
		this.type = type || 'all';

		if (this.type !== 'all') {
			this._reaction = Reaction.fromType(this.type);
		}
	}

	add(reaction: ReactionData) {
		this.reactions.push(reaction);
	}

	get count() {
		return this.reactions.length;
	}

	get icon() {
		return this._reaction?.coin;
	}
}
